import React from 'react';

export interface ChartTooltip {
  children: React.ReactNode;
}

export interface BasicChartTooltipProps {
  label: string;
  timeLabel: string;
  value: string;
  color: string;
  unit: string;
}

export function ChartTooltip({ children }: ChartTooltip) {
  return <div className="flex flex-col items-center gap-1 bg-background/90 p-3 rounded shadow-md">{children}</div>;
}

export function BasicChartTooltip(props: BasicChartTooltipProps) {
  const { label, timeLabel, value, color, unit } = props;
  return (
    <ChartTooltip>
      <div className="flex flex-col items-center min-w-[8em]">
        <div className="flex text-[0.8rem] font-semibold text-center" dangerouslySetInnerHTML={{ __html: label }} />
        <div className="text-white font-semibold text-center" dangerouslySetInnerHTML={{ __html: timeLabel }} />
        <div className="flex text-md font-semibold text-center" style={{ color }}>
          {value} {unit}
        </div>
      </div>
    </ChartTooltip>
  );
}

interface ComparisonChartTooltipProps {
  label: string;
  xValue: string;
  xUnit: string;
  yValue: string;
  yUnit: string;
  color: string;
}

export function ComparisonChartTooltip(props: ComparisonChartTooltipProps) {
  const { label, xValue, xUnit, yValue, yUnit, color } = props;
  return (
    <ChartTooltip>
      <div className="flex flex-col min-w-[8em] items-center gap-2">
        {label && (
          <div className="text-white text-sm font-semibold text-center" dangerouslySetInnerHTML={{ __html: label }} />
        )}
        <div className="flex flex-row gap-6">
          <div className="flex flex-col items-center">
            <div style={{ color }} className="font-semibold text-lg">
              {xValue}
            </div>
            <div className="text-white/70 text-sm">({xUnit})</div>
          </div>
          <div className="flex flex-col items-center">
            <div className="text-white font-semibold text-lg">{yValue}</div>
            <div className="text-white/70 text-sm">({yUnit})</div>
          </div>
        </div>
      </div>
    </ChartTooltip>
  );
}
